import carSourceShare from './carSourceShare.json';

export default { carSourceShare };
